/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/campaign_country_performance/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCampaignCountryPerformanceCampaignId } from "./constants";
import type {
  GetEngagementAppGroupIdCampaignCountryPerformanceCampaignIdProps,
  GetEngagementAppGroupIdCampaignCountryPerformanceCampaignIdResult,
} from "./types";
import { isGetEngagementAppGroupIdCampaignCountryPerformanceCampaignIdResult } from "./validators";

export const getEngagementAppGroupIdCampaignCountryPerformanceCampaignId = reactQueryFetcherAdapter(
  engagementAppGroupIdCampaignCountryPerformanceCampaignId,
  (
    signal: AbortSignal,
    { appGroupId, campaignId, startDate, endDate }: GetEngagementAppGroupIdCampaignCountryPerformanceCampaignIdProps
  ): Promise<GetEngagementAppGroupIdCampaignCountryPerformanceCampaignIdResult> => {
    return fetch(
      `/engagement/${appGroupId}/campaign_country_performance/${campaignId}`,
      "GET",
      { start: startDate, end: endDate },
      { signal }
    );
  },
  isGetEngagementAppGroupIdCampaignCountryPerformanceCampaignIdResult
);
